import { RankedForm } from '@/features/factory/subfactories/RankedForm'

/** Sub-route /factory/ranked — wraps the Ranked (Top N) form component. */
export function RankedPage() {
  return <RankedForm />
}
